import { render, staticRenderFns } from "./ViewInstitutionPage.vue?vue&type=template&id=b22447c4&scoped=true&"
import script from "./ViewInstitutionPage.vue?vue&type=script&lang=js&"
export * from "./ViewInstitutionPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewInstitutionPage.vue?vue&type=style&index=0&id=b22447c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22447c4",
  null
  
)

export default component.exports